import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

export default function removeUnderlineStyle({ $removeUnderline }: ButtonStyleProps) {
  if ($removeUnderline) {
    return css`
      text-decoration: none !important;
    `;
  }
}
